(function () {
  // Wave 12 / wpm_33 — Flutter quick-shop post-ATC CTA morph (−|qty|+).
  // Cap mirrors kCustomerMaxUnitsPerPurchaseLine. Keep-open from Wave 10 stays intact.
  var CAP = 6;
  var ATTR_BUSY = 'data-eros-qb-busy';

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function openQuickBuyModals() {
    return Array.prototype.filter.call(document.querySelectorAll('quick-buy-modal'), function (modal) {
      return modal.open || modal.hasAttribute('open');
    });
  }

  function formatLineTotal(cents) {
    var amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    if (window.ErosUI && typeof window.ErosUI.formatMoneyIqd === 'function') {
      return window.ErosUI.formatMoneyIqd(Math.round(amount / 100));
    }
    try {
      var currency =
        (window.Shopify && Shopify.currency && Shopify.currency.active) || 'IQD';
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0,
      }).format(amount / 100);
    } catch (e) {
      return String(Math.round(amount / 100));
    }
  }

  function getVariantId(modal) {
    var form = modal.querySelector('form[action*="/cart/add"]');
    if (!form || !form.id) return null;
    var idInput = form.elements.namedItem('id');
    if (!idInput || !idInput.value) return null;
    return parseInt(idInput.value, 10);
  }

  function findLineForVariant(cart, variantId) {
    if (!cart || !cart.items || !variantId) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === variantId) return cart.items[i];
    }
    return null;
  }

  function effectiveCap(line) {
    var cap = CAP;
    if (line && line.quantity_rule && line.quantity_rule.max != null) {
      cap = Math.min(cap, parseInt(line.quantity_rule.max, 10) || CAP);
    }
    return cap;
  }

  /**
   * Exactly ONE bar per modal (owner report 2026-09-07: two identical bars
   * stacked after adding). Prestige re-renders the product form on variant
   * change and can leave a previous <buy-buttons> — with our bar still in
   * it — in the DOM beside the new one; a per-<buy-buttons> lookup then
   * happily created a second bar. Look up at modal level, adopt a stray bar
   * into the current <buy-buttons>, and drop any extras.
   */
  function ensureSplitBar(buyButtons) {
    var scope = buyButtons.closest('quick-buy-modal') || buyButtons;
    var bars = scope.querySelectorAll('[data-eros-qb-split]');
    var existing = null;
    for (var i = 0; i < bars.length; i++) {
      if (!existing) {
        existing = bars[i];
      } else {
        bars[i].parentNode && bars[i].parentNode.removeChild(bars[i]);
      }
    }
    if (existing) {
      if (existing.parentNode !== buyButtons) buyButtons.appendChild(existing);
      return existing;
    }

    var bar = document.createElement('div');
    bar.className = 'eros-qb-split-bar';
    bar.setAttribute('data-eros-qb-split', '');
    bar.hidden = true;
    bar.innerHTML =
      '<button type="button" class="eros-qb-split-bar__cap" data-eros-qb-inc aria-label="+">' +
      '<span aria-hidden="true">+</span>' +
      '</button>' +
      '<span class="eros-qb-split-bar__divider" aria-hidden="true"></span>' +
      '<div class="eros-qb-split-bar__center">' +
      '<span class="eros-qb-split-bar__qty" data-eros-qb-qty>1</span>' +
      '<span class="eros-qb-split-bar__total" data-eros-qb-total></span>' +
      '</div>' +
      '<span class="eros-qb-split-bar__divider" aria-hidden="true"></span>' +
      '<button type="button" class="eros-qb-split-bar__cap" data-eros-qb-dec aria-label="-">' +
      '<span aria-hidden="true">−</span>' +
      '</button>';

    buyButtons.appendChild(bar);
    return bar;
  }

  function setMorphVisible(buyButtons, morph) {
    var bar = ensureSplitBar(buyButtons);
    bar.hidden = !morph;
    buyButtons.classList.toggle('eros-qb-buy-buttons--morphed', morph);
  }

  function renderLine(buyButtons, line) {
    if (!line || !line.quantity || line.quantity <= 0) {
      setMorphVisible(buyButtons, false);
      return;
    }

    var bar = ensureSplitBar(buyButtons);
    setMorphVisible(buyButtons, true);

    var qtyEl = bar.querySelector('[data-eros-qb-qty]');
    var totalEl = bar.querySelector('[data-eros-qb-total]');
    var inc = bar.querySelector('[data-eros-qb-inc]');
    var dec = bar.querySelector('[data-eros-qb-dec]');
    var qty = line.quantity;
    var cap = effectiveCap(line);
    var atCap = qty >= cap;

    if (qtyEl) qtyEl.textContent = String(qty);
    if (totalEl) {
      // ADR-331 W0: the catalogue line price; final_line_price carries Shopify
      // automatic discounts the order never gets.
      var total = formatLineTotal(line.original_line_price != null ? line.original_line_price : line.line_price);
      totalEl.textContent = total ? '(' + total + ')' : '';
      totalEl.hidden = !total;
    }

    bar.dataset.lineKey = line.key;
    bar.dataset.qty = String(qty);
    bar.dataset.cap = String(cap);

    if (inc) {
      inc.disabled = atCap;
      inc.setAttribute('aria-disabled', atCap ? 'true' : 'false');
      inc.classList.toggle('is-disabled', atCap);
    }
    if (dec) {
      dec.disabled = false;
      dec.removeAttribute('aria-disabled');
      dec.classList.remove('is-disabled');
    }
  }

  function syncModal(modal, cart) {
    var buyButtons = modal.querySelector('buy-buttons');
    if (!buyButtons) return;
    // The quick-shop sheet now renders the shared add-to-cart stepper
    // (snippets/eros-pdp-cart-stepper.liquid, quick_shop: true), which owns
    // «ضيف لسلتك» → − qty + by itself. Morphing here too stacked a second
    // bar under it after every cart change (owner screenshot 2026-10-03).
    if (modal.querySelector('[data-eros-pdp-cart-stepper]')) {
      var stray = modal.querySelectorAll('[data-eros-qb-split]');
      for (var i = 0; i < stray.length; i++) stray[i].parentNode.removeChild(stray[i]);
      buyButtons.classList.remove('eros-qb-buy-buttons--morphed');
      return;
    }
    // Any bar living in a stale <buy-buttons> (see ensureSplitBar) is
    // adopted or removed BEFORE we decide visibility, so a hidden state can
    // never leave an orphan bar showing.
    ensureSplitBar(buyButtons);
    var variantId = getVariantId(modal);
    if (!variantId) {
      setMorphVisible(buyButtons, false);
      return;
    }
    renderLine(buyButtons, findLineForVariant(cart, variantId));
  }

  async function fetchCart() {
    var response = await fetch(root() + 'cart.js', { credentials: 'same-origin' });
    if (!response.ok) throw new Error('cart.js failed');
    return response.json();
  }

  async function changeLineQuantity(lineKey, quantity) {
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    document.documentElement.dispatchEvent(
      new CustomEvent('theme:loading:start', { bubbles: true })
    );

    var response = await fetch(root() + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        sections: sectionsToBundle.join(','),
      }),
    });

    document.documentElement.dispatchEvent(
      new CustomEvent('theme:loading:end', { bubbles: true })
    );

    var cartContent = await response.json();
    if (!response.ok) {
      throw new Error(cartContent.description || 'cart/change failed');
    }

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', {
        bubbles: true,
        detail: {
          baseEvent: 'line-item:change',
          cart: cartContent,
        },
      })
    );

    return cartContent;
  }

  async function syncOpenModals(cart) {
    var modals = openQuickBuyModals();
    if (!modals.length) return;
    var resolved = cart;
    if (!resolved) {
      try {
        resolved = await fetchCart();
      } catch (e) {
        return;
      }
    }
    modals.forEach(function (modal) {
      syncModal(modal, resolved);
    });
  }

  async function onSplitClick(event) {
    var button = event.target.closest('[data-eros-qb-inc], [data-eros-qb-dec]');
    if (!button) return;
    var bar = button.closest('[data-eros-qb-split]');
    var modal = button.closest('quick-buy-modal');
    if (!bar || !modal || bar.hasAttribute(ATTR_BUSY)) return;

    var lineKey = bar.dataset.lineKey;
    var qty = parseInt(bar.dataset.qty, 10) || 0;
    var cap = parseInt(bar.dataset.cap, 10) || CAP;
    if (!lineKey || qty <= 0) return;

    var next = button.hasAttribute('data-eros-qb-inc') ? qty + 1 : qty - 1;
    if (button.hasAttribute('data-eros-qb-inc') && qty >= cap) return;
    if (next < 0) next = 0;

    bar.setAttribute(ATTR_BUSY, 'true');
    try {
      var cart = await changeLineQuantity(lineKey, next);
      syncModal(modal, cart);
    } catch (e) {
      try {
        syncModal(modal, await fetchCart());
      } catch (ignored) {
        /* no-op */
      }
    } finally {
      bar.removeAttribute(ATTR_BUSY);
    }
  }

  function onVariantAdd(event) {
    var form = event.target;
    if (!form || !form.closest) return;
    var modal = form.closest('quick-buy-modal');
    if (!modal) return;
    var cart = event.detail && event.detail.cart;
    if (cart) {
      syncModal(modal, cart);
    } else {
      syncOpenModals(null);
    }
  }

  function onCartChange(event) {
    var cart = event.detail && event.detail.cart;
    if (!openQuickBuyModals().length) return;
    // Keep drawer suppress (Wave 10). Morph sync only — never hide modal.
    syncOpenModals(cart || null);
  }

  function onDialogShown(event) {
    var modal = event.target;
    if (!modal || modal.localName !== 'quick-buy-modal') return;
    // Content is injected in show(); give Prestige a tick to mount buy-buttons.
    requestAnimationFrame(function () {
      syncOpenModals(null);
    });
  }

  function observeModal(modal) {
    if (modal.__erosQbObserved) return;
    modal.__erosQbObserved = true;
    var timer = null;
    var observer = new MutationObserver(function () {
      if (!(modal.open || modal.hasAttribute('open'))) return;
      var buyButtons = modal.querySelector('buy-buttons');
      if (!buyButtons) return;
      // Re-attach after product-rerender swaps buy-buttons.
      if (buyButtons.querySelector('[data-eros-qb-split]')) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        syncOpenModals(null);
      }, 40);
    });
    observer.observe(modal, { childList: true, subtree: true });
  }

  function boot() {
    document.addEventListener('click', onSplitClick);
    document.addEventListener('variant:add', onVariantAdd);
    document.addEventListener('cart:change', onCartChange);
    document.addEventListener('dialog:after-show', onDialogShown);
    document.querySelectorAll('quick-buy-modal').forEach(observeModal);

    var bodyObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.localName === 'quick-buy-modal') observeModal(node);
          else if (node.querySelectorAll) {
            node.querySelectorAll('quick-buy-modal').forEach(observeModal);
          }
        });
      });
    });
    bodyObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
